import { isMobile } from '@/until/common';

// rem等比适配配置文件
// 基准大小
const baseSize = 16
// 设置 rem 函数
function setRem () {
  let val;
  let clientWidth = document.documentElement.clientWidth;
  // 判断浏览器函数
  if(isMobile()) {
    val = 750;// 移动端
  }else{
    val = 1920;
     // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。
    if(clientWidth < 1240){
      clientWidth = 1240
    }
  }
 
  const scale = clientWidth / val
  // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 1) + 'px'
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem()
}